class PolygonUtils {
  /**
   * Calculate points of an offset polygon
   * @see {@link http://csharphelper.com/blog/2016/01/enlarge-a-polygon-in-c/}
   * @private
   * @param {number[]} points - polygon coordinates
   * @param {number} offset
   * @returns {number[]} - offset points
   */
  static offsetPolygon(points, offset) {
    const offsetPoints = [], length = points.length;
    offset = PolygonUtils.isPolygonClockwise(points) ? offset : -1 * offset;
    for (let j = 0; j < length; j += 2) {
      let i = j - 2;
      i < 0 && (i += length);
      const k = (j + 2) % length;
      let v1x = points[j] - points[i], v1y = points[j + 1] - points[i + 1], len = Math.sqrt(v1x * v1x + v1y * v1y);
      v1x /= len, v1y /= len, v1x *= offset, v1y *= offset;
      const norm1x = -v1y, norm1y = v1x, pij1 = [points[i] + norm1x, points[i + 1] + norm1y], pij2 = [points[j] + norm1x, points[j + 1] + norm1y];
      let v2x = points[k] - points[j], v2y = points[k + 1] - points[j + 1];
      len = Math.sqrt(v2x * v2x + v2y * v2y), v2x /= len, v2y /= len, v2x *= offset, v2y *= offset;
      const norm2x = -v2y, norm2y = v2x, pjk1 = [points[j] + norm2x, points[j + 1] + norm2y], pjk2 = [points[k] + norm2x, points[k + 1] + norm2y], intersectPoint = PolygonUtils.findIntersection(pij1[0], pij1[1], pij2[0], pij2[1], pjk1[0], pjk1[1], pjk2[0], pjk2[1]);
      intersectPoint && offsetPoints.push(...intersectPoint);
    }
    return offsetPoints;
  }
  /**
   * Determine the intersection point of two line segments
   * @see http://paulbourke.net/geometry/pointlineplane/
   * @private
   * @param {number} x1 - x-coordinate of start point at first line
   * @param {number} y1 - y-coordinate of start point at first line
   * @param {number} x2 - x-coordinate of end point at first line
   * @param {number} y2 - y-coordinate of end point at first line
   * @param {number} x3 - x-coordinate of start point at second line
   * @param {number} y3 - y-coordinate of start point at second line
   * @param {number} x4 - x-coordinate of end point at second line
   * @param {number} y4 - y-coordinate of end point at second line
   * @returns [x, y] coordinates of intersection
   */
  static findIntersection(x1, y1, x2, y2, x3, y3, x4, y4) {
    const denominator = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1), numeratorA = (x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3), numeratorB = (x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3);
    if (denominator === 0)
      return numeratorA === 0 && numeratorB === 0 ? [(x1 + x2) / 2, (y1 + y2) / 2] : null;
    const uA = numeratorA / denominator;
    return [x1 + uA * (x2 - x1), y1 + uA * (y2 - y1)];
  }
  /**
   * Determine polygon are clockwise or counterclockwise
   * @see {@link https://stackoverflow.com/questions/1165647}
   * @private
   * @param {number[]} polygon - polygon coordinates
   * @returns {boolean} - true if polygon is clockwise
   */
  static isPolygonClockwise(polygon) {
    let sum = 0;
    for (let i = 0, j = polygon.length - 2; i < polygon.length; j = i, i += 2)
      sum += (polygon[i] - polygon[j]) * (polygon[i + 1] + polygon[j + 1]);
    return sum > 0;
  }
}
export {
  PolygonUtils
};
//# sourceMappingURL=PolygonUtils.mjs.map
